var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 59,
    viewBox: "0 0 51 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2253_1266)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 21.5,
    r: 20.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 38H37.5L25.5 50L13.5 38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 21.5,
    r: 17.5,
    fill: "#2C7D3D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2253_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.92 15.01C32.72 14.42 32.16 14 31.5 14H20.5C19.84 14 19.29 14.42 19.08 15.01L17 21V29C17 29.55 17.45 30 18 30H19C19.55 30 20 29.55 20 29V28H32V29C32 29.55 32.45 30 33 30H34C34.55 30 35 29.55 35 29V21L32.92 15.01ZM20.5 25C19.67 25 19 24.33 19 23.5C19 22.67 19.67 22 20.5 22C21.33 22 22 22.67 22 23.5C22 24.33 21.33 25 20.5 25ZM31.5 25C30.67 25 30 24.33 30 23.5C30 22.67 30.67 22 31.5 22C32.33 22 33 22.67 33 23.5C33 24.33 32.33 25 31.5 25ZM19 20L20.5 15.5H31.5L33 20H19Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2253_1266",
    x: 0,
    y: 0,
    width: 51,
    height: 59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2253_1266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2253_1266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2253_1266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.9ee8bf0c52ce3d915cba2b085cc5cce0.svg";
export { ForwardRef as ReactComponent };